// extracted by mini-css-extract-plugin
module.exports = {"newStudentsGrid":"home_newStudentsGrid__3UOVl"};